import * as RadixAvatar from '@radix-ui/react-avatar';
import { __DEV__ } from '@chakra-ui/utils';

export const AvatarFallback = RadixAvatar.Fallback;

if (__DEV__) {
  AvatarFallback.displayName = 'AvatarFallback';
}
